import localScaleManager from "../../../../helpers/LocalScaleManager";
import { CenterPot } from "./centerPot";
import { LeftPot } from "./leftPot";
import { RightPot } from "./rightPot";
import { TopPot } from "./topPot";
import { Parser } from "../../../../helpers/parser";

export class Pots {
  constructor(scene, pot, table) {
    this.scene = scene;
    this.pot = pot;
    this.table = table;
    this.text = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeue",
      Parser.convertToXLetters(`Pot : ${Parser.toCurrency(pot)}`, 16)
    );
    this.table.poolArray.push(this.text);

    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);
    this.initX = 0;
    this.initY = 0;
    this.tableWidth = 0;
    this.tableHeight = 0;
    this.centerPot = new CenterPot(scene, 0, this.table);
    this.leftPot = new LeftPot(scene, 0, this.table);
    this.rightPot = new RightPot(scene, 0, this.table);
    this.topPot = new TopPot(scene, 0, this.table);
    this.visibilityControls(false);
  }
  visibilityControls(visibility) {
    if (this.text.visible !== visibility) this.text.setVisible(visibility);
    this.centerPot.visibilityControls(visibility);
    this.leftPot.visibilityControls(visibility);
    this.rightPot.visibilityControls(visibility);
    this.topPot.visibilityControls(visibility);
  }
  handleGameState(state) {
    this.changeText(state.pot);
    if (!state.pot) {
      if (this.text.visible) this.text.setVisible(false);
    } else if (!this.text.visible) this.text.setVisible(true);
    if (state.state !== "End") {
      this.centerPot.handleGameState(state);
      this.leftPot.handleGameState(state);
      this.rightPot.handleGameState(state);
      this.topPot.handleGameState(state);
    }
  }
  changeText(pot) {
    this.pot = pot;
    const potDemo = Parser.convertToXLetters(
      `Pot : ${pot.toLocaleString()}`,
      16
    );
    this.text.setText(potDemo);
    this.text.setX(this.initX + (this.tableWidth - this.text.width) / 2);
  }
  winPotChips(sidePotRoundInfos) {
    const sidePots = sidePotRoundInfos;
    for (let i = 0; i < sidePots.length; i++) {
      const sidePot = sidePots[i];
      if (sidePot && sidePot.value) {
        sidePot.winners.forEach((winner) => {
          this.table.findSeatByPosition(winner.position).win(winner.win);
        });
        if (i === 0) this.centerPot.goToWinners(sidePot.winners);
        else if (i === 1) this.leftPot.goToWinners(sidePot.winners);
        else if (i === 2) this.rightPot.goToWinners(sidePot.winners);
        else if (i === 3) this.topPot.goToWinners(sidePot.winners);
      }
    }

    // sidePots[0].winners.forEach((winner) => {
    //   this.table.findSeatByPosition(winner.position).win(winner.win);
    // });
    // this.centerPot.goToWinners(sidePots[0].winners);
    // if (sidePots[1] && sidePots[1].value) {
    //   sidePots[1].winners.forEach((winner) => {
    //     this.table.findSeatByPosition(winner.position).win(winner.win);
    //   });
    //   this.leftPot.goToWinners(sidePots[1].winners);
    // }
    // if (sidePots[2] && sidePots[2].value) {
    //   sidePots[2].winners.forEach((winner) => {
    //     this.table.findSeatByPosition(winner.position).win(winner.win);
    //   });
    //   this.rightPot.goToWinners(sidePots[2].winners);
    // }
    // if (sidePots[3] && sidePots[3].value) {
    //   sidePots[3].winners.forEach((winner) => {
    //     this.table.findSeatByPosition(winner.position).win(winner.win);
    //   });
    //   this.topPot.goToWinners(sidePots[3].winners);
    // }
  }
  handleVisibilityChange(hidden) {
    this.centerPot.handleVisibilityChange(hidden);
    this.leftPot.handleVisibilityChange(hidden);
    this.rightPot.handleVisibilityChange(hidden);
    this.topPot.handleVisibilityChange(hidden);
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    this.initX = initX;
    this.initY = initY;
    this.tableWidth = width;
    this.tableHeight = height;
    const textSize = Math.min(width * 0.15, height * 0.15);
    localScaleManager.scaleBitMapText(
      this.text,
      textSize,
      textSize,
      Math.min(this.text.width, this.text.height) * 0.2,
      1,
      false
    );
    this.text.setPosition(
      initX + (width - this.text.width) / 2,
      initY + height * 0.39
    );

    this.centerPot.positionControls(width, height, initX, initY);
    this.leftPot.positionControls(width, height, initX, initY);
    this.rightPot.positionControls(width, height, initX, initY);
    this.topPot.positionControls(width, height, initX, initY);
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {
    this.initX = initX;
    this.initY = initY;
    this.tableWidth = width;
    this.tableHeight = height;

    this.text.setPosition(
      initX + (width - this.text.width) / 2,
      initY + height * 0.39
    );

    this.centerPot.reposition(width, height, initX, initY);
    this.leftPot.reposition(width, height, initX, initY);
    this.rightPot.reposition(width, height, initX, initY);
    this.topPot.reposition(width, height, initX, initY);
  }
  remove() {
    this.text.destroy();
    this.centerPot.remove();
    this.leftPot.remove();
    this.rightPot.remove();
    this.topPot.remove();
  }
}
